/**
 * VAT rates ARCA recognises, keyed as they appear in exports (percent as text, comma or dot).
 * Stored as the decimal string with a dot: "10.5". Exento and no gravado are line kinds, not rates.
 */
export const VAT_RATES = ["0", "2.5", "5", "10.5", "21", "27"];
export function isVatRate(value) {
    return VAT_RATES.includes(value);
}
/** Basis points, so `21%` of cents is integer arithmetic: cents * 2100 / 10000. */
export function rateBasisPoints(rate) {
    return Math.round(Number(rate) * 100);
}
/**
 * Line kinds of a voucher (Article X rule 3: one line per rate, never aggregated).
 * `gravado` carries a rate, a neto and its IVA; the rest carry one amount.
 */
export const LINE_KINDS = [
    "gravado",
    "exento",
    "no_gravado",
    "percepcion_iva",
    "percepcion_iibb",
    "otro_tributo",
];
export const LINE_KIND_LABELS = {
    gravado: "Gravado",
    exento: "Exento",
    no_gravado: "No gravado",
    percepcion_iva: "Percepción de IVA",
    percepcion_iibb: "Percepción de IIBB",
    otro_tributo: "Otros tributos",
};
/** What a purchase is, as the IVA return opens the crédito fiscal (and the previous system asks). */
export const PURCHASE_KINDS = ["bienes", "servicios", "bienes_uso"];
export const PURCHASE_KIND_LABELS = {
    bienes: "Bienes",
    servicios: "Servicios",
    bienes_uso: "Bienes de uso",
};
/** Convenio Multilateral jurisdiction codes, as ARCA and the previous system number them. */
export const IIBB_JURISDICTIONS = [
    { code: 901, name: "Capital Federal" },
    { code: 902, name: "Buenos Aires" },
    { code: 903, name: "Catamarca" },
    { code: 904, name: "Córdoba" },
    { code: 905, name: "Corrientes" },
    { code: 906, name: "Chaco" },
    { code: 907, name: "Chubut" },
    { code: 908, name: "Entre Ríos" },
    { code: 909, name: "Formosa" },
    { code: 910, name: "Jujuy" },
    { code: 911, name: "La Pampa" },
    { code: 912, name: "La Rioja" },
    { code: 913, name: "Mendoza" },
    { code: 914, name: "Misiones" },
    { code: 915, name: "Neuquén" },
    { code: 916, name: "Río Negro" },
    { code: 917, name: "Salta" },
    { code: 918, name: "San Juan" },
    { code: 919, name: "San Luis" },
    { code: 920, name: "Santa Cruz" },
    { code: 921, name: "Santa Fe" },
    { code: 922, name: "Santiago del Estero" },
    { code: 923, name: "Tierra del Fuego" },
    { code: 924, name: "Tucumán" },
];
//# sourceMappingURL=alicuotas.js.map